var exports = {
  "A_": "xdbfd91f1--8b8905--village_card",
  "rZ": "xdbfd91f1--8b8905--breadcrumbs_wrapper",
  "YB": "xdbfd91f1--8b8905--village_card-top",
  "I5": "xdbfd91f1--8b8905--village_card-main",
  "vG": "xdbfd91f1--8b8905--village_card-aside",
  "AY": "xdbfd91f1--8b8905--village_card-footer",
  "ho": "xdbfd91f1--8b8905--bottom_banner",
  "uP": "xdbfd91f1--8b8905--village_card-aside-inner",
  "t8": "xdbfd91f1--8b8905--village_card-aside-wrapper",
  "OJ": "xdbfd91f1--8b8905--village_card-aside-inner-transition",
  "_q": "xdbfd91f1--8b8905--village_card-aside-inner--with-menu",
};

module.exports = exports;
